var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require(("@/assets/images/membership/" + _vm.memberStatus + ".svg")),"alt":_vm.memberStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }